
// Production release: 2026-03-04
import React, { useState, useCallback, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import * as CONFIG from '../../Components/_config';
import ls from 'local-storage';
import Header from '../Dashboard/Header';
import FooterStrict from '../Dashboard/FooterStrict';
import DataTable from "react-data-table-component";
import { renderTooltip } from '../../Components/Helper';
import { OverlayTrigger } from 'react-bootstrap';
import Analytics from "../../Assets/images/analytics.png";
// import DeleteIcon from '../../Assets/images/delete-black.jpg';
import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { handleErrorResponse } from '../../helper';

const UPCListTable = React.memo(function UPCListTable({ title, upcdata, onAdd, onDelete, showDelete, DelIcon, onDeleteUPC, isMyBrand, onDeleteBrand }) {

  // DataTable columns
  // State for UPC delete confirmation
  const [showUPCConfirm, setShowUPCConfirm] = React.useState(false);
  const [pendingDeleteUPCId, setPendingDeleteUPCId] = React.useState(null);
  const [filterText, setFilterText] = React.useState("");

  // Local, defensive default for data
  const rows = React.useMemo(() => Array.isArray(upcdata) ? upcdata : [], [upcdata]);

  // Filtered rows for searchch
  const filteredRows = React.useMemo(() => {
    if (!filterText) return rows;
    const q = filterText.toLowerCase();
    return rows.filter((r) =>
      String(r.upc || "").toLowerCase().includes(q) ||
      String(r.product_name || "").toLowerCase().includes(q) ||
      String(r.category_name || "").toLowerCase().includes(q)
    );
  }, [rows, filterText]);

  // Polished table styles
  const customStyles = React.useMemo(() => ({
    table: {
      style: {
        borderRadius: 12,
        overflow: 'hidden',
        boxShadow: '0 4px 14px rgba(0,0,0,0.06)'
      }
    },
    headRow: {
      style: {
        backgroundColor: '#f8fafc',
        minHeight: '48px',
        borderTop: '1px solid #e5e7eb',
        borderBottom: '1px solid #e5e7eb'
      }
    },
    headCells: {
      style: {
        fontSize: '12px',
        color: '#334155',
        letterSpacing: '.04em',
        textTransform: 'uppercase',
        fontWeight: 600
      }
    },
    rows: {
      style: {
        minHeight: '46px'
      },
      highlightOnHoverStyle: {
        backgroundColor: 'rgba(59,130,246,0.08)',
        transition: 'background-color 0.15s ease'
      }
    },
    cells: {
      style: {
        paddingTop: '10px',
        paddingBottom: '10px'
      }
    },
    pagination: {
      style: {
        borderTop: '1px solid #e5e7eb'
      }
    }
  }), []);

  const handleShowUPCConfirm = (upcId) => {
    setPendingDeleteUPCId(upcId);
    setShowUPCConfirm(true);
  };
  const handleConfirmUPCDelete = () => {
    setShowUPCConfirm(false);
    if (pendingDeleteUPCId && onDeleteUPC) {
      onDeleteUPC(pendingDeleteUPCId);
    }
    setPendingDeleteUPCId(null);
  };
  const handleCancelUPCDelete = () => {
    setShowUPCConfirm(false);
    setPendingDeleteUPCId(null);
  };

  const columns = [
    {
      name: "UPC11",
      selector: row => row.upc,
      sortable: true,
      grow: 0.6,
      cell: row => (
        <span>
          {row.upc}
        </span>
      )
    },
    { name: "Product Name", selector: row => row.product_name, sortable: true, left: true, grow: 2 },
    // { name: "Item Code", selector: row => row.item_code, sortable: true, left: true },
    {
      name: "Category",
      selector: row => row.category_name,
      sortable: true,
      left: true,
      grow: 1,
      cell: row => (
        <span style={{ background: '#eef2ff', color: '#3730a3', padding: '2px 0',  fontWeight: 600 }}>
          {row.category_name || '—'}
        </span>
      )
    },
    {
      name: "DELETE",
      selector: row => row.upc,
      cell: row => (
        showDelete && onDeleteUPC ? (
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip('Delete')}
          >
            <button
              type="button"
              aria-label="Delete UPC"
              className="btn btn-outline-danger"
              style={{ background: 'transparent', color: '#ef4444', border: 'none', padding: 6, cursor: 'pointer', borderRadius: 8 }}
              onClick={() => handleShowUPCConfirm(row.category_brand_upc_id)}
            >
              <DelIcon />
            </button>
          </OverlayTrigger>
        ) : null
      ),
      center: true,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true
    },
  ];


  // State for showing confirmation modal
  const [showConfirm, setShowConfirm] = React.useState(false);
  const handleDeleteBrandWithConfirm = () => setShowConfirm(true);
  const handleConfirmDelete = () => {
    setShowConfirm(false);
    onDeleteBrand();
  };
  const handleCancelDelete = () => setShowConfirm(false);

  return (
    <>
      <div className="Card Coupons mb-20" style={{ borderRadius: 12, overflow: 'hidden', border: '1px solid #e5e7eb', height: 'auto' }}>
        <div className="Card_Header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 16px', background: '#3d8ecc', color: '#fff' }}>
          <div className='d-flex align-items-center gap-4'>
            <h5 style={{ margin: 0 }}>{`${title} (${rows.length})`}</h5>
            {!isMyBrand && (
              <div className="Card_Header_Right">
                <button
                  type="button"
                  onClick={handleDeleteBrandWithConfirm}
                  className="del-icon"
                  title="Delete Brand"
                >
                  <DelIcon width={18} height={18} />
                </button>
              </div>
            )}
          </div>
          <div className="Card_Header_Right" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ position: 'relative' }}>
              <input
                type="text"
                placeholder="Search UPCs, product, category..."
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
                style={{
                  borderRadius: 8,
                  border: '1px solid rgba(255,255,255,0.6)',
                  background: 'rgba(247, 243, 243, 1)',
                  color: '#000000ff',
                  padding: '6px 10px',
                  outline: 'none',
                  width: 260
                }}
              />
            </div>
            <button
              type="button"
              onClick={onAdd}
              className="btn btn-primary add-upcs-btn"
              style={{ background: '#fff', color: '#3d8ecc', border: 'none', fontWeight: 700 }}
            >
              + Add UPCs
            </button>
          </div>
        </div>
        <div className="Card_Body">
          <div className="table-responsive Coupons_Table">
            <DataTable
              columns={columns}
              data={filteredRows}
              customStyles={customStyles}
              highlightOnHover
              striped
              dense
              pagination
              noDataComponent={<span style={{ color: '#6b7280' }}>No UPCs found</span>}
            />
          </div>
        </div>
      </div>
      {/* Bootstrap Confirmation Modal for Brand Delete */}
      {showConfirm && (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Delete</h5>
                <button type="button" className="btn-close" aria-label="Close" onClick={handleCancelDelete}></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete competitor brand?</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={handleCancelDelete}>Cancel</button>
                <button type="button" className="btn btn-danger" onClick={handleConfirmDelete}>Delete</button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Bootstrap Confirmation Modal for UPC Delete */}
      {showUPCConfirm && (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Delete</h5>
                <button type="button" className="btn-close" aria-label="Close" onClick={handleCancelUPCDelete}></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this UPC?</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={handleCancelUPCDelete}>Cancel</button>
                <button type="button" className="btn btn-danger" onClick={handleConfirmUPCDelete}>Delete</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
});

const DelIcon = React.memo(function DelIcon({ width = 20, height = 20 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
    >
      {/* Lid */}
      <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      {/* Top bar */}
      <path d="M3 6h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      {/* Bin body */}
      <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      {/* Inner lines */}
      <path d="M10 11v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <path d="M14 11v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );
});

const CreateEditCategoryAnalyzer = () => {
  const history = useHistory();
  const { categoryguid } = useParams();
  const [categoryGuid, setCategoryGuid] = useState('');
  const [addLoadingGuid, setAddLoadingGuid] = useState(null);
  const [categoryDetails, setCategoryDetails] = useState(null);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const location = useLocation()
  const url = new URLSearchParams(location.search)
  const category_id = url.get('category_id') ?? ""

  const [confirmAdd, setConfirmAdd] = useState(null);
  const [showSetupConfirm, setShowSetupConfirm] = useState(false);

  const getCategoryDetails = useCallback(async (guid) => {
    if (!guid) return;
    const brand_id = ls.get('selectedbrand')?.[0]?.guid || '';
    if (!brand_id) return;
    setLoading(true);
    try {
      const res = await axios.get(
        `${CONFIG.API_URL}brand/categorybyid/${guid}`,
        { headers: CONFIG.config_head.headers }
      );
      if (res.status === 200 && res.data?.Message) {
        setCategoryDetails(res.data.Message);
        setCategoryName(res.data.Message.category_name);
      }
    } catch (error) {
      handleErrorResponse(error);
      toast.error('Failed to fetch category details');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (categoryguid) {
      setCategoryGuid(categoryguid);
      getCategoryDetails(categoryguid);
    }
  }, [categoryguid, getCategoryDetails]);

  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      const brand_id = ls.get('selectedbrand')?.[0]?.guid || '';
      if (!brand_id) return;
      setLoading(true);
      try {
        const res = await axios.get(`${CONFIG.API_URL}brand/allcategory/${brand_id}`, {
          headers: CONFIG.config_head.headers
        });
        if (res.status === 200 && res.data?.Message) {
          setCategories(res.data.Message);
        }
      } catch (error) {
        toast.error('Failed to fetch categories');
        handleErrorResponse(error);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [isBrandPopup, setPopupBrandVisible] = useState(false);
  const [isPopupdel, setPopupdelVisible] = useState(false);
  const [categoryName, setCategoryName] = useState('');
  const [loading, setLoading] = useState(false);
  const [brandName, setBrandName] = useState('');
  const [brandFile, setBrandFile] = useState(null);
  const [brandLoading, setBrandLoading] = useState(false);
  // Form validity for Brand upload (file always required; name required only when creating new brand)
  const isBrandFormValid = !!brandFile && (!!selectedBrand || !!brandName.trim());

  const MAX_BRANDS = 5;
  const MAX_UPCS = 200;
  const competitorBrands = categoryDetails?.brands?.filter(b => !b.is_my_brand) || [];
  const competitorBrandCount = competitorBrands.length;
  const competitorUPCCount = competitorBrands.reduce((sum, b) => sum + (b.upcs?.length || 0), 0);
  const canAddBrand = competitorBrandCount < MAX_BRANDS;
  const canAddUPCs = competitorUPCCount < MAX_UPCS;

  // CreateCategory function
  const CreateCategory = async (e) => {
    e.preventDefault();
    const b_guid = ls.get('selectedbrand')?.[0]?.guid || '';
    if (!categoryName.trim()) {
      toast.error("Category Name can't be blank", { theme: "colored" });
      return;
    }
    setLoading(true);
    try {
      let res;
      if (categoryGuid) {
        res = await axios.put(
          `${CONFIG.API_URL}brand/customcategory/${b_guid}/${categoryGuid}`,
          { category_name: categoryName.trim(), category_status: 1 },
          { headers: CONFIG.config_head.headers }
        );
      } else {
        res = await axios.post(
          `${CONFIG.API_URL}brand/customcategory/${b_guid}`,
          { category_name: categoryName.trim() },
          { headers: CONFIG.config_head.headers }
        );
      }
      if (res.status === 200) {
        toast.success(categoryGuid ? 'Custom Category Updated Successfully' : 'Custom Category Added Successfully');
        setCategoryGuid(res.data.Message.category_guid);
        getCategoryDetails(res.data.Message.category_guid);
        closeModal();
      }
    } catch (error) {
      if (error.response?.status === 403) {
        toast.error(error.response.data.Message);
        ls.clear('token');
        ls.clear('brands');
        window.location.href = '/login';
      } else {
        toast.error(error.response?.data?.Message || (categoryGuid ? 'Failed to update category' : 'Failed to add category'));
      }
    } finally {
      setLoading(false);
    }
  };

  const openModal = useCallback(() => setIsModalVisible(true), []);
  const closeModal = useCallback(() => setIsModalVisible(false), []);
  const togglePopup = useCallback(() => setPopupVisible((v) => !v), []);
  const toggleBrandPopup = useCallback((brand = null) => {
    setSelectedBrand(brand);
    setBrandName(brand ? brand.brand_name : '');
    // reset file selection every time popup opens or switches context
    setBrandFile(null);
    setPopupBrandVisible((v) => !v);
  }, []);
  const toggledelPopup = useCallback(() => setPopupdelVisible((v) => !v), []);
  const handleAddUPCs = async (category_guid) => {
    const brand_id = ls.get('selectedbrand')?.[0]?.guid || '';
    if (!brand_id || !category_guid) return;
    setAddLoadingGuid(category_guid);
    setLoading(true);
    try {
      const res = await axios.post(
        `${CONFIG.API_URL}brand/addupcsbycategory/${brand_id}/${categoryGuid}`,
        { category: category_guid },
        { headers: CONFIG.config_head.headers }
      );
      if (res.status === 200 && res.data) {
        toast.success('UPCs added successfully');
        getCategoryDetails(categoryGuid);
      }
    } catch {
      toast.error('Failed to add UPCs');
    } finally {
      setAddLoadingGuid(null);
      setLoading(false);
    }
  };
  const handleSaveBrandUPCs = async () => {
    if (!brandName.trim()) {
      toast.error("Brand Name can't be blank", { theme: "colored" });
      return;
    }
    if (!brandFile) {
      toast.error("Please select a file to upload", { theme: "colored" });
      return;
    }
    if (!selectedBrand && !canAddBrand) {
      toast.error(`You've reached the limit of ${MAX_BRANDS} competitor brands.`, { theme: "colored" });
      return;
    }
    if (!canAddUPCs) {
      toast.error(`You've reached the limit of ${MAX_UPCS} competitor UPCs.`, { theme: "colored" });
      return;
    }
    setBrandLoading(true);
    setLoading(true);
    const brand_id = ls.get('selectedbrand')?.[0]?.guid || '';
    const formData = new FormData();
    formData.append('brand_name', brandName.trim());
    formData.append('file', brandFile);
    formData.append('cac_brand_id', selectedBrand ? selectedBrand.category_brand_id : '');
    try {
      const res = await axios.post(
        `${CONFIG.API_URL}brand/addcompupcs/${brand_id}/${categoryGuid}`,
        formData,
        {
          headers: {
            ...CONFIG.config_head.headers,
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      if (res.status === 200 && res.data) {
        toast.success('Brand UPCs uploaded successfully');
        setBrandName('');
        setBrandFile(null);
        setPopupBrandVisible(false);
        getCategoryDetails(categoryGuid);
        setShowSetupConfirm(true)
      }
    } catch {
      toast.error('Failed to upload Brand UPCs');
    } finally {
      setBrandLoading(false);
      setLoading(false);
    }
  };
  // Function to delete brand UPC
  const handleDeleteBrandUPC = async (category_brand_upc_id) => {
    if (!category_brand_upc_id) return;
    const brand_id = ls.get('selectedbrand')?.[0]?.guid || '';
    setLoading(true);
    try {
      const res = await axios.delete(
        `${CONFIG.API_URL}brand/deletecustomcategoryupc/${category_brand_upc_id}`,
        {
          headers: CONFIG.config_head.headers
        }
      );
      if (res.status === 200) {
        toast.success('Brand UPC deleted successfully');
        if (categoryGuid) getCategoryDetails(categoryGuid);
      }
    } catch (error) {
      toast.error(error?.response?.data?.Message || 'Failed to delete Brand UPC');
    } finally {
      setLoading(false);
    }
  };
  // Function to delete custom category brand
  const handleDeleteCustomCategoryBrand = async (category_brand_id) => {
    if (!category_brand_id) return;
    setLoading(true);
    try {
      const res = await axios.delete(
        `${CONFIG.API_URL}brand/removecategorybrand/${category_brand_id}`,
        {
          headers: CONFIG.config_head.headers,

        }
      );
      if (res.status === 200) {
        toast.success('Brand removed successfully');
        if (categoryGuid) getCategoryDetails(categoryGuid);
      }
    } catch (error) {
      toast.error(error?.response?.data?.Message || 'Failed to remove brand');
    } finally {
      setLoading(false);
    }
  };
  // showLoader and hideLoader are handled by setLoading above
  const Loader = () => <div id="cover-spin"></div>;
  // Determine if there is at least one brand marked as my brand that has UPCs
  const hasMyBrandUPCs = !!(categoryDetails?.brands?.some(
    (b) => b.is_my_brand && Array.isArray(b.upcs) && b.upcs.length > 0
  ));
  // Determine if there is at least one competitor brand (not my brand)
  const hasCompetitorBrands = !!(categoryDetails?.brands?.some(
    (b) => !b.is_my_brand
  ));

  const handleAddClick = (guid) => setConfirmAdd(guid);

  const handleConfirmAdd = async () => {
    if (!confirmAdd) return;
    await handleAddUPCs(confirmAdd);
    setConfirmAdd(null);
  };

  const AnalysisIcon = ({ width = 25, height = 25 }) => (
    <Link to={`/category-analyzer`}>
      <img
        src={Analytics}
        alt="Analysis Icon"
        width={width}
        height={height}
      />
    </Link>
  );
  return (
    <>
      <Header />
      {loading ? <Loader /> : null}
      <div className='ContentBlock pt-40 pb-24 Main_Block'>
        <div className='edit-catagory'>
          <div className="container-fluid">
            <div className='row'>
              <div className='col-12'>
                <div>
                  <span>Competitive Analysis {categoryName}</span>
                  <div className='input-cate cate-controls' style={{ display: 'flex', alignItems: 'center' }}>
                    {/* Left group: Textbox + Save */}
                    <div className='cate-controls-left'>
                      <input
                        type="text"
                        placeholder="Enter Category Name"
                        className="form-control cate-input"
                        value={categoryName}
                        onChange={e => setCategoryName(e.target.value)}
                      />
                    
                    </div>
                    {/* Right group: Analysis + Back */}
                    <div className='cate-controls-right' style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '10px' }}>
                      {categoryGuid && (
                        <button type="button" className="btn btn-outline-primary analysis-btn" onClick={() => history.push(`/category-analyzer/${category_id}`)}>
                          <AnalysisIcon />Analysis
                        </button>
                      )}
                      <button
                        type="button"
                        className="btn btn-outline-secondary back-btn"
                        onClick={() => history.push('/custom-analysis-categories')}
                        title="Back to Competitive 360 Analysis"
                      >
                        &laquo; Back to Competitive Analysis
                      </button>
                    </div>
                  </div>

                      <div style={{marginTop:'15px'}}>
                      <button type="button" className="btn btn-outline-primary save-btn" style={{marginRight:'10px',background:'#fff',color:'#3B94CA'}} onClick={() => history.push('/custom-analysis-categories')} title="cancel"> 
                       Cancel
                           </button>
                      <button className="btn btn-outline-primary save-btn"  onClick={CreateCategory} disabled={loading}>
                        Save
                      </button>
                      </div>
                </div>
              </div>
            </div>
            <div className="row g-3 mt-0">
              <div className="col-12 mb-20">
                {categoryGuid && (
                  <UPCListTable title="My UPCs"
                    isMyBrand={categoryDetails?.brands?.find(b => b.is_my_brand)?.is_my_brand}
                    upcdata={categoryDetails?.brands?.find(b => b.is_my_brand)?.upcs || []} onAdd={openModal} showDelete={true}
                    DelIcon={DelIcon}
                    onDeleteUPC={handleDeleteBrandUPC} />
                )}
              </div>
              <div className="col-12">
                <div className='add-btn-wrap'>
                  {categoryGuid && hasMyBrandUPCs && (
                    <>
                    <div style={{display:'flex',alignItems:'center',gap:'10px',marginBottom:'10px'}}>
                      <h2 className='brand-title' style={{margin:'0'}}>Competitor UPCs</h2>
                    </div>
                      <OverlayTrigger
                        placement="top"
                        delay={{ show: 250, hide: 400 }}
                        overlay={!canAddBrand ? renderTooltip(`Maximum ${MAX_BRANDS} competitor brands allowed`) : <span />}
                      >
                        <span style={{ display: 'inline-block' }}>
                          <button
                            onClick={() => canAddBrand && toggleBrandPopup(null)}
                            className='add-btn'
                            style={!canAddBrand ? { opacity: 0.5, cursor: 'not-allowed', pointerEvents: 'none' } : {}}
                            disabled={!canAddBrand}
                          >
                            +ADD BRAND AND UPCS
                          </button>
                        </span>
                      </OverlayTrigger>
                    </>
                  )}

                  {isModalVisible && (
                    <div className="modal-overlay category-popup" onClick={closeModal}>
                      <div className="modal-content" style={{ padding: '0', border: 'none' }} onClick={e => e.stopPropagation()}>
                        <div className="Card Coupons" style={{ border: 'none' }}>
                          <button onClick={closeModal} className='close-btn'>x</button>
                          <div className="Card_Header">
                            <h5>ADD ITEMS FROM CATEGORIES</h5>
                          </div>
                          <div className="Card_Body">
                            <div className="table-responsive Coupons_Table">
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th>Categories</th>
                                    <th style={{ textAlign: "left" }}>ADD</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {categories.map((item, index) => (
                                    <tr key={item.upc_category_guid || index}>
                                      <td>{item.category_name}</td>
                                      {/* <td style={{ textAlign: "left" }}>
                                        <button
                                          onClick={() => handleAddUPCs(item.upc_category_guid)}
                                          disabled={addLoadingGuid === item.upc_category_guid}
                                        >
                                          {addLoadingGuid === item.upc_category_guid ? 'Saving...' : 'ADD'}
                                        </button>
                                      </td> */}
                                      <td style={{ textAlign: "left" }}>
                                        <button
                                           onClick={() => handleAddClick(item.upc_category_guid)}
                                          disabled={addLoadingGuid === item.upc_category_guid}
                                        >
                                          {addLoadingGuid === item.upc_category_guid ? 'Saving...' : 'ADD'}
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}


                    {confirmAdd && (
                     <div className="modal-overlay" >
                      <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                          <div className="modal-header" style={{padding:'0 0 15px 0'}}>
                            <button
                              type="button"
                              className="btn-close"
                              aria-label="Close"
                              onClick={() => setConfirmAdd(null)}
                            ></button>
                          </div>
                         <div className="modal-body" style={{textAlign:'left',padding:'15px 0'}}>
                              <p>Great — you’ve added your items for comparison! Next, add your competitor brands and UPCs to generate a complete 360° competitive view.</p>
                            </div>
                          <div className="modal-footer" style={{padding:'15px 0 0'}}>
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={handleConfirmAdd}
                            >
                              OK
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {isPopupVisible && (
                    <div className="modal-overlay" onClick={togglePopup}>
                      <div className="modal-content" onClick={e => e.stopPropagation()}>
                        <div className="modal-body p-0 pb-20">
                          <div className="input-label mb-10 mt-5">
                            <label htmlFor="brand_name" className="form-label">Brand Name</label>
                            <input type="text" className="form-control" placeholder="Brand Name" name="brand_name" />
                          </div>
                          <div className="input-label">
                            <label htmlFor="upc" className="form-label">UPCs for Brand</label>
                            <textarea className="form-control" placeholder="UPCs for Brand" name="upc" rows="4" />
                          </div>
                        </div>
                        <div className="edit-cate-btn">
                          <button className="del-btn" onClick={togglePopup}><span>Delete</span></button>
                          <div>
                            <button className="cancel-btn" onClick={togglePopup}><span>Cancel</span></button>
                            <button className="save-btn" onClick={togglePopup}>Save</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {isBrandPopup && (
                    <div className="modal-overlay" onClick={() => toggleBrandPopup(null)}>
                      <div className="modal-content" onClick={e => e.stopPropagation()}>
                        <div className="modal-body p-0 pb-20">
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                            <label className="form-label" style={{ fontSize: '18px', textAlign: 'left', fontWeight: '600', margin: 0 }}>Upload Brand UPCs</label>
                            <div style={{ display: 'flex', gap: '12px', fontSize: '12px', fontWeight: 600 }}>
                              <span style={{ color: competitorBrandCount >= MAX_BRANDS ? '#dc2626' : '#6b7280' }}>
                                Brands: {competitorBrandCount}/{MAX_BRANDS}
                              </span>
                              <span style={{ color: competitorUPCCount >= MAX_UPCS ? '#dc2626' : '#6b7280' }}>
                                UPCs: {competitorUPCCount}/{MAX_UPCS}
                              </span>
                            </div>
                          </div>
                          <div className="input-label mb-10 mt-5">
                            <label htmlFor="brand_name" className="form-label">Brand Name</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Brand Name"
                              name="brand_name"
                              value={brandName}
                              onChange={e => setBrandName(e.target.value)}
                              disabled={brandLoading || selectedBrand}
                            />
                          </div>
                          <div className="input-label">
                            <input
                              type="file"
                              className='upload-input'
                              onChange={e => setBrandFile(e.target.files[0])}
                              disabled={brandLoading}
                              accept=".csv"
                              required
                            />
                            <small className='note mt-10' style={{ fontWeight: '500' }}>Note:</small>
                            <small className='note'>You can upload brand items from a CSV file that includes two columns—<span>UPC and productname.</span> The columns must appear in this exact order, and the column names must match exactly as shown.</small>
                          </div>
                        </div>
                        <div className="edit-cate-btn" style={{ justifyContent: 'end' }}>
                          <div>
                            <button className="cancel-btn" onClick={() => toggleBrandPopup(null)} disabled={brandLoading}><span>Cancel</span></button>
                            <button className="save-btn"   onClick={handleSaveBrandUPCs} >
                              {brandLoading ? 'Saving...' : 'Save'}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                    {showSetupConfirm && (
                      <div className="modal-overlay" onClick={() => setShowSetupConfirm(false)}>
                        <div
                          className="modal-dialog modal-dialog-centered"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div className="modal-content">
                            <div className="modal-header" style={{padding:'0 0 15px 0'}}>
                              <button
                                type="button"
                                className="btn-close"
                                aria-label="Close"
                                onClick={() => setShowSetupConfirm(false)}
                              ></button>
                            </div>
                            <div className="modal-body" style={{ textAlign: "left", padding: "15px 0" }}>
                              <p>
                                Your competitor UPCs have been uploaded and the category is now being processed. This typically takes <strong>5–7 minutes</strong>.
                              </p>
                              <p>
                                Please check back on the category list — the status will update from <strong>Processing</strong> to <strong>Live</strong> once it’s ready.
                              </p>
                            </div>
                            <div className="modal-footer" style={{padding:'15px 0 0'}}>
                              <button
                                type="button"
                                className="btn btn-primary"
                                style={{ backgroundColor: "#3D8ECC" }}
                                onClick={() => {
                                  setShowSetupConfirm(false);
                                }}
                              >
                                OK
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                </div>
              </div>
            </div>

            {/* Competitor brand tables — outside the flex row to ensure proper stacking */}
            <div className="row mt-0">
              <div className="col-12">
                    {!hasCompetitorBrands && (
                        <>
                          <h4 className='brand-title'>No brands setup for comparison. Please click +Add Brand and UPCs</h4>
                        </>
                      )}

                {categoryDetails && categoryDetails.brands && categoryDetails.brands.filter(b => !b.is_my_brand).map((brand, idx) => (
                  <UPCListTable
                    key={brand.category_brand_id || idx}
                    title={brand.brand_name}
                    upcdata={brand.upcs || []}
                    onAdd={() => toggleBrandPopup(brand)}
                    showDelete={true}
                    DelIcon={DelIcon}
                    onDeleteUPC={handleDeleteBrandUPC}
                    onDeleteBrand={() => handleDeleteCustomCategoryBrand(brand.category_brand_id)}
                  />
                ))}

                {isPopupdel && (
                  <div className="modal-overlay" onClick={toggledelPopup}>
                    <div className="modal-content" onClick={e => e.stopPropagation()}>
                      <div className="modal-body p-0 pb-20">
                        <label className="form-label" style={{ fontSize: '18px', textAlign: 'left', fontWeight: '600' }}>Are you sure you want to delete this record?</label>
                        <span className='alert'>This action cannot be undone.</span>
                      </div>
                      <div className="edit-cate-btn" style={{ justifyContent: 'end' }}>
                        <div>
                          <button className="cancel-btn" onClick={toggledelPopup}><span>Delete</span></button>
                          <button className="save-btn" onClick={toggledelPopup}>Cancel</button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <FooterStrict />
      </div>
    </>
  );
};
export default CreateEditCategoryAnalyzer;
